// One place maps agent generation onto the open-shift detail look. Generic
// widgets take this variant instead of reading `agent_generation` themselves.

export type OutreachDetailChrome = 'default' | 'compact';

export function outreachDetailChrome(
    outreach: { readonly agent_generation?: string | null } | null | undefined,
): OutreachDetailChrome {
    return outreach?.agent_generation === 'v3' ? 'compact' : 'default';
}

export const COMPACT_OUTREACH_DETAIL_REFERENCE_BUTTON_CLASSNAME =
    'text-muted-foreground hover:text-foreground h-6 gap-0.5 px-1.5 text-xs font-normal shadow-none [&_svg]:size-3';

export function outreachDetailReferenceButtonClassName(
    chrome: OutreachDetailChrome,
): string | undefined {
    return chrome === 'compact'
        ? COMPACT_OUTREACH_DETAIL_REFERENCE_BUTTON_CLASSNAME
        : undefined;
}

export function outreachDetailReferenceButtonVariant(
    chrome: OutreachDetailChrome,
): 'ghost' | 'outline' {
    return chrome === 'compact' ? 'ghost' : 'outline';
}

export function outreachDetailReferenceIconClassName(
    chrome: OutreachDetailChrome,
    spinning = false,
): string {
    if (chrome === 'compact') {
        return spinning ? 'size-3.5 animate-spin' : 'size-3.5';
    }
    return spinning ? 'mr-2 h-4 w-4 animate-spin' : 'mr-2 h-4 w-4';
}

export function outreachDetailsPanelClassName(
    chrome: OutreachDetailChrome,
): string {
    return chrome === 'compact'
        ? 'px-4 pt-4.5 pb-2 sm:px-6'
        : 'border-t border-b px-4 py-5 sm:px-6 sm:py-6';
}

export function outreachDetailsHeaderClassName(
    chrome: OutreachDetailChrome,
): string {
    return chrome === 'compact'
        ? 'flex flex-col gap-2 border-b border-border pb-2.5 sm:flex-row sm:items-center sm:justify-between'
        : 'mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between';
}

export function outreachDetailsTableClassName(
    chrome: OutreachDetailChrome,
): string {
    return chrome === 'compact'
        ? 'border-separate border-spacing-0 [&_td]:border [&_td]:border-transparent [&_td]:px-2 [&_td]:py-2 [&_td]:text-xs [&_td]:leading-5 [&_td]:whitespace-normal [&_tr]:border-transparent [&_tr]:hover:bg-transparent'
        : '[&_td]:whitespace-normal [&_tr]:hover:bg-transparent';
}

export function outreachDetailsStatusRowClassName(
    chrome: OutreachDetailChrome,
): string {
    return chrome === 'compact'
        ? 'flex flex-wrap items-center gap-1.5'
        : 'flex flex-wrap items-center gap-3';
}

export function outreachShiftsTableClassName(
    chrome: OutreachDetailChrome,
): string {
    return chrome === 'compact'
        ? '[&_td]:py-1.5 [&_th]:h-8'
        : '[&_td]:whitespace-normal [&_th]:whitespace-normal';
}
